<div
  #chartContainer
  data-testid="line-chart-container"
  [class]="className"
  [style.height]="height"
  [style.width]="width"
></div>
